import type {ReactElement} from 'react';
import {useState} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editor-version-history-mobile-panel';

export default function PosterEditorBleedModal(): ReactElement<any> {
  const [height] = useState('400px');
  const maxWidth = '800px';

  const versionHistorySelectedVersion = useAppSelector((state) => {
    return state.posterEditor.versionHistorySelectedVersion;
  });

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_VERSION_HISTORY_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
      bottomSheetCloseThreshold={100}
      doesBottomSheetHaveSnapPoints
      snapPointsForBottomSheet={[400, 700]}
      disableDragToClose={versionHistorySelectedVersion !== null}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-version-history-mobile-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const onPosterEditorVersionHistoryModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_VERSION_HISTORY_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
